/* eslint-disable @typescript-eslint/no-unused-vars */

import { catAppAPIClient } from "@/app/apiClient";
import { getCurrentUser } from "@/app/firebase/auth";
import { GetUserAccessResponse } from "@anu-its/cat-grpc-pb/js/anu/cat_app/acl_pb";

const emptyResponse = {
  userRoles: {},
} as GetUserAccessResponse;

async function GetUserAccess(): Promise<GetUserAccessResponse> {
  const user = await getCurrentUser();
  if (!user) {
    return emptyResponse;
  }

  try {
    return await catAppAPIClient.getUserAccess({});
  } catch (err) {
    return emptyResponse;
  }
}

export { GetUserAccess };
